import Vue from "vue"
import { ModalPlugin } from "bootstrap-vue"

Vue.use(ModalPlugin)